export const ftlMenuItems = [
  { label: "Trip Management", path: "/fleet/trips" },
  { label: "Vehicles", path: "/master/vehicles" },
  { label: "Drivers", path: "/master/drivers" },

];